/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NatureFxLightningBIcon16Regular = forwardRef('NatureFxLightningBIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.217.845C8.806.103 10 .52 10 1.467V6h2.982a1 1 0 0 1 .783 1.622l-5.982 7.533C7.194 15.897 6 15.48 6 14.533V10H3.018a1 1 0 0 1-.783-1.622L8.217.845ZM8.5 2.9 4.053 8.5H6.5a1 1 0 0 1 1 1v3.6l4.447-5.6H9.5a1 1 0 0 1-1-1V2.9Z" })));
});
